import { TypesVistoriaOEA } from "./vistoriaOEA";

export const TypesOitoPontosOEA = {
    TOGGLE_PONTO: "oitoPontosOEA/TOGGLE_PONTO",
    TOGGLE_EXPANSAO: "oitoPontosOEA/TOGGLE_EXPANSAO",
    ADICIONAR_FOTOS: "oitoPontosOEA/ADICIONAR_FOTOS",
    ATUALIZAR_FOTO: "oitoPontosOEA/ATUALIZAR_FOTO",
    REMOVER_FOTO: "oitoPontosOEA/REMOVER_FOTO",
    RESETAR: "oitoPontosOEA/RESETAR"
};

export const INITIAL = {
    pontosVistoriados: [],
    pontosExpandidos: [],
    fotosPorPonto: {}
};

export default function oitoPontosOEAReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesVistoriaOEA.INICIAR_SESSAO:
            return INITIAL;

        case TypesOitoPontosOEA.TOGGLE_PONTO: {
            const { id } = action.payload;
            const jaMarcado = state.pontosVistoriados.includes(id);
            if (jaMarcado) {
                return {
                    ...state,
                    pontosVistoriados: state.pontosVistoriados.filter(
                        x => x !== id
                    )
                };
            }
            return {
                ...state,
                pontosVistoriados: [...state.pontosVistoriados, id],
                pontosExpandidos: state.pontosExpandidos.includes(id)
                    ? state.pontosExpandidos
                    : [...state.pontosExpandidos, id]
            };
        }

        case TypesOitoPontosOEA.TOGGLE_EXPANSAO: {
            const { id } = action.payload;
            return {
                ...state,
                pontosExpandidos: state.pontosExpandidos.includes(id)
                    ? state.pontosExpandidos.filter(x => x !== id)
                    : [...state.pontosExpandidos, id]
            };
        }

        case TypesOitoPontosOEA.ADICIONAR_FOTOS: {
            const { pontoId, fotos } = action.payload;
            return {
                ...state,
                fotosPorPonto: {
                    ...state.fotosPorPonto,
                    [pontoId]: [
                        ...(state.fotosPorPonto[pontoId] ?? []),
                        ...fotos
                    ]
                }
            };
        }

        case TypesOitoPontosOEA.ATUALIZAR_FOTO: {
            const { pontoId, hash, patch } = action.payload;
            const lista = state.fotosPorPonto[pontoId] ?? [];
            return {
                ...state,
                fotosPorPonto: {
                    ...state.fotosPorPonto,
                    [pontoId]: lista.map(f =>
                        f.hash === hash ? { ...f, ...patch } : f
                    )
                }
            };
        }

        case TypesOitoPontosOEA.REMOVER_FOTO: {
            const { pontoId, hash } = action.payload;
            const lista = state.fotosPorPonto[pontoId] ?? [];
            return {
                ...state,
                fotosPorPonto: {
                    ...state.fotosPorPonto,
                    [pontoId]: lista.filter(f => f.hash !== hash)
                }
            };
        }

        case TypesOitoPontosOEA.RESETAR:
            return INITIAL;

        default:
            return state;
    }
}

function togglePonto(id) {
    return { type: TypesOitoPontosOEA.TOGGLE_PONTO, payload: { id } };
}

function toggleExpansao(id) {
    return { type: TypesOitoPontosOEA.TOGGLE_EXPANSAO, payload: { id } };
}

function adicionarFotos(pontoId, fotos) {
    return {
        type: TypesOitoPontosOEA.ADICIONAR_FOTOS,
        payload: { pontoId, fotos }
    };
}

function atualizarFoto(pontoId, hash, patch) {
    return {
        type: TypesOitoPontosOEA.ATUALIZAR_FOTO,
        payload: { pontoId, hash, patch }
    };
}

function removerFoto(pontoId, hash) {
    return {
        type: TypesOitoPontosOEA.REMOVER_FOTO,
        payload: { pontoId, hash }
    };
}

function resetar() {
    return { type: TypesOitoPontosOEA.RESETAR };
}

export const OitoPontosOEAActions = {
    togglePonto,
    toggleExpansao,
    adicionarFotos,
    atualizarFoto,
    removerFoto,
    resetar
};
